// FORMS
export const FETCH_FORMS = "FETCH_FORMS";
export const FETCH_FORM = "FETCH_FORM";
export const SAVE_FORM = "SAVE_FORM";
export const SAVE_DRAFT = "SAVE_DRAFT";
export const UPDATE_FORM = "UPDATE_FORM";
export const CLEAR_FORM = "CLEAR_FORM";



// WEBPACK FOOTER //
// ./src/store/actions/actionTypes.js